import Hashes from 'jshashes'
export default message => new Hashes.SHA256().hex(message)
